module.exports = __webpack_public_path__ + "img/carNum4.a5c1f3ed.png";